const initialFeedState = {
  feeds: {
    /*
    [feedGroup:feedId]: {
      feedGroup: String,
      feedId: String,
      hasNew: Boolean,
      hasNextPage: Boolean,
      activities: [{id: String<activityId>, isNew: Boolean}]
    },
    */
  },
  activities: {
    /*
    [activityId]: {
      item: Object<StreamActivity>,
      reactionCounts: {[reactionType]: Int},
      reactions: [{
        id: String,
        type: String,
        item: Object<StreamReaction>,
        own: Boolean
      }],
      commentCount: Int,
      comments: [{
        id: String,
        item: Object<StreamReaction>,
        replyCount: Int,
        reactionCounts: {[reactionType]: Int},
        replies: [{
          item: Object<StreamReaction>
        }],
      }],
      isNew: Boolean
    }
     */
  },
};

export default initialFeedState;
